import $ from 'jquery';
import {find, isEqual, wrap} from 'lodash-es';
import packageProtection from './packageProtection';
import {rechargeUtil} from '../lib/rechargeUtil';

export const util = {

  /**
   * Add url param or array of params, and push history state.
   * @param {String} key
   * @param {String} value
   * @param {[String, String][]} params - ie. [['step', '3'], ['foo', 'bar'], ['checkout', 'true']]
   */
  insertUrlParam(key, value, params = []) {
    let kvp = document.location.search.substr(1);
    if (key && value) {
      params.push([key, value]);
    }

    params.forEach(([key, value], index) => {
      var key = encodeURI(key);

      const subValues = value.split('|');
      for (var i in subValues) {
        subValues[i] = encodeURI(subValues[i]);
      }
      var value = subValues.join('|');

      kvp = kvp.split('&');

      var i = kvp.length; let x; while (i--) {
        x = kvp[i].split('=');

        if (x[0] == key) {
          x[1] = value;
          kvp[i] = x.join('=');
          break;
        }
      }

      if (i < 0) { kvp[kvp.length] = [key, value].join('='); }

      if (kvp[0] == '') {
        kvp.splice(0, 1);
      }

      kvp = kvp.join('&');
    });
    // this will reload the page, it's likely better to store this until finished
    const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${kvp}`;
    window.history.pushState({path: newurl}, '', newurl);
  },

  parseDate(input) {
    const parts = input.split('-');
    return new Date(parts[0], parts[1] - 1, parts[2]);
  },

  dateToISOString(date) {
    return date.toISOString().split('T')[0];
  },

  validEmail(email) {
    const emailReg = /^\S+@\S+\.\S+$/;

    return email.match(emailReg);
  },

  validZip(zip) {
    let reUS = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/, // US Zip
      reCA = /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/; // CA Zip

    return zip.match(reUS) || zip.match(reCA);
  },

  getUrlVars() {
    const vars = {};
    const parts = window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      vars[key] = value;
    });
    return vars;
  },

  getUrlParam(parameter, defaultvalue) {
    if (window.location.search.indexOf(parameter) > -1) {
      return this.getUrlVars()[parameter];
    }
    return defaultvalue;
  },

  getDataAttribute(selector) {
    return selector.replace('[', '').replace(']', '');
  },

  clearCart(cb) {

    $.ajax({
      url: '/cart/clear.js',
      type: 'POST',
      dataType: 'json',
      success(response) {
        if (cb) {
          cb(response);
        }
      },
    });
  },

  getMealsVariant(variants) {
    return variants.find((variant) => {
      return variant.title.includes('Default');
    }) || variants[0];
  },

  initQuantityListeners(plus, minus, $container) {
    const self = this;
    $container.on('click', plus, updateQuantity);
    $container.on('click', minus, updateQuantity);

    function updateQuantity(e) {
      e.stopImmediatePropagation();
      const attr = e.handleObj.selector;

      const lineAttribute = self.getDataAttribute(attr);
      const qtyAttribute = self.getDataAttribute('[data-new-qty]');
      const line = Number(e.target.getAttribute(lineAttribute));
      const qty = Number(e.target.getAttribute(qtyAttribute));
      const productTitle = e.target.getAttribute('data-product-title');
      const productId = Number(e.target.getAttribute('data-product-id'));

      window.basket.updateQuantity(line, qty);

      if (attr === '[data-plus-one]') {

        /**
         * GTM - addToCart
         */
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'addToCart',
          productProperties: {
            product_title: productTitle,
            product_id: productId,
          },
        });
        window.Shopify.analytics.publish('mosaicAddToCart', {
          product_title: productTitle,
          product_id: productId,
        });
      } else if (attr === '[data-minus-one]') {

        /**
         * GTM - removeFromCart
         */
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'removeFromCart',
          productProperties: {
            product_title: productTitle,
            product_id: productId,
          },
        });
        window.Shopify.analytics.publish('mosaicRemoveFromCart', {
          product_title: productTitle,
          product_id: productId,
        });
      }
    }
  },

  returnToPortal() {
    this.clearCart();
    window.location.href = '/account#/dashboard';
  },

  async getCurrentSubscriptions() {
    window.mosaic.recharge.bundleSelection = await rechargeUtil.getBundleSelection();
    return window.mosaic.recharge.bundleSelection.items;
  },

  async addSubscriptionsToCart(itemThreshold) {
    const self = this;
    window.basket.empty();
    window.basket.setPackageProtection(false);

    const subscriptions = await this.getCurrentSubscriptions();

    const subscriptionMeals = subscriptions.filter((sub) => {
      const product_id = sub.external_product_id || sub.shopify_product_id.toString();
      if (product_id == packageProtection.product.id) {
        window.basket.setPackageProtection(true);
        return false;
      }
      return true;
    });

    const subscriptionCount = subscriptionMeals.reduce((count, sub) => (count += sub.quantity), 0);

    if (!(itemThreshold && subscriptionCount > itemThreshold)) {
      subscriptionMeals.forEach((sub) => {
        const product = window.mosaic.products.find(
          (p) => p.id.toString() === ( sub.external_product_id || sub.shopify_product_id.toString())
        );
        const variant = self.getMealsVariant(product.variants);

        window.basket.add({
          defer: true,
          variant,
          product,
          quantity: sub.quantity,
          properties: sub.properties,
        });
      });

      window.basket._update();
    }
  },

  isType(object, type, defaultObject) {
    if (typeof object === type) {
      return object;
    } else {
      return defaultObject;
    }
  },

  checkAvailability({
    errorCallback,
    completeCallback,
    user_email,
    shipping_zipcode,
    order_type,
    emptyBasket = true,
  } = {}) {
    if (emptyBasket) {
      window.basket.empty();
    }
    const email = this.isType(user_email, 'string', null);
    const zipCode = this.isType(shipping_zipcode, 'string', this.getUrlParam('zip_code'));
    const orderType = this.isType(order_type, 'string', 'new');
    const error = this.isType(errorCallback, 'function', (err) => {
      // proceed if error
      console.log('error with server', err);
    });
    const callback = this.isType(completeCallback, 'function', (res) => {});

    const data = {
      ...email && {
        email,
      },
      shipping_zipcode: zipCode,
      order_type: orderType,
    };

    $.ajax({
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      url: `${window.location.origin}/apps/mosaic-api/check-availability/`,
      dataType: 'json',
      data: JSON.stringify(data),
      error,
    }).then(callback);
  },

  getAvailableDeliveryDates({
    zipcode,
    callback,
    error,
  } = {}) {
    zipcode = this.isType(zipcode, 'string', this.getUrlParam('zip_code'));

    $.ajax({
      url: `${window.location.origin}/apps/mosaic-api/available-delivery-dates/`,
      dataType: 'json',
      data: {
        zipcode,
        order_type: 'new',
      },
      error,
    }).then(callback);
  },

  async getSellingPlanId(productId, frequency) {
    const productResponse = await fetch(`https://static.rechargecdn.com/store/${window.shopifyDomain}/product/2022-06/${productId}.json`);
    const productData = await productResponse.json();
    const sellingPlan = find(
      productData.product.plans,
      (plan) => (
        plan.order_interval_frequency === Number(frequency) &&
        plan.interval_unit === 'week'
      ),
    );
    if (!sellingPlan) {
      throw new Error(`Selling plan not found matching requested frequency of ${frequency} for ${productId}.`);
    }
    return sellingPlan.external_plan_id;
  },

  async getShopifyProductPayload(product, quantity, shippingInterval, onetimeOrder) {
    const variant = this.getMealsVariant(product.variants);

    const payload = {
      quantity,
      merchandiseId: `gid://shopify/ProductVariant/${variant.id}`,
    };

    if (!onetimeOrder) {
      const sellingPlanId = await this.getSellingPlanId(
        product.id,
        shippingInterval,
      );
      payload.sellingPlanId = `gid://shopify/SellingPlan/${sellingPlanId}`;

    }

    return payload;
  },

  async _sendShopifyCartRequest(cartAttributes, lineItems, customerEmail) {

    const formattedCartAttributes = [];

    for (const [key, value] of Object.entries(cartAttributes)) {
      if (value) {
        formattedCartAttributes.push({
          key,
          value,
        });
      }
    }

    const cartInput = {
      lines: lineItems,
      attributes: formattedCartAttributes,
    };

    if (customerEmail) {
      cartInput.buyerIdentity = {
        email: window.urlParams.get('email'),
        countryCode: 'US',
      };
    }

    const payload = {
      query: `
        mutation cartCreateMutation($cartInput: CartInput) {
          cartCreate(input: $cartInput) {
            cart {
              id
              checkoutUrl
            }
            userErrors {
              field
              code
              message
            }
            warnings {
              target
              code
              message
            }
          }
        }
      `,
      variables: {
        cartInput,
      },
    };

    const {storefrontApiToken} = window.themeConfiguration;
    const cartCreateResponse = await fetch(
      `https://${window.shopifyDomain}/api/2025-10/graphql.json`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontApiToken,
        },
        body: JSON.stringify(payload),
      },
    );

    const cartCreateData = await cartCreateResponse.json();

    try {
      const checkoutUrl = cartCreateData.data.cartCreate.cart.checkoutUrl;
      if (checkoutUrl) { return checkoutUrl; }
    } catch (_error) {

      /* continue to errror handliner if we cannot find checkout URL as expected. */
    }

    // Everything after this point is error handling.

    if (!cartCreateData.hasOwnProperty('data')) {
      throw Error('ShopifyCartCreateNoDataError', cartCreateData);
    }

    const userErrors = cartCreateData.data.cartCreate.userErrors || [];

    if (userErrors.length > 0) {
      /* eslint-disable shopify/prefer-early-return */
      userErrors.forEach((error) => {
        // If the error is related to the customer's email, we can send them to
        // checkout without the email prefilled.
        if (isEqual(error.field, ['input', 'buyerIdentity', 'email'])) {
          throw Error('ShopifyCartCreateEmailError', error.message);
        }
      });
      /* eslint-enable shopify/prefer-early-return */

      // This is a user error, but not one we know how to handle.
      throw Error(
        'ShopifyCartCreateUserError',
        userErrors,
      );
    }

    // Somthing very unexpected happened.
    throw Error('ShopifyCartCreateUnknownError', cartCreateData);
  },

  cartItemToProduct: (item) => window.mosaic.products.find(
    (candidateProduct) => candidateProduct.id === Number(item.product_id),
  ),

  getPrimararyCollection: (product) => {
    if (product.id === window.themeConfiguration.packageProtection.product.id) {
      return { id: window.themeConfiguration.bundleArchitecture.packageProtectionCollectionId };
    }
    return (product.collections || [])
      .find((collection) => window.themeConfiguration.displayCollections.includes(
      collection.handle,
  ));
  },

  getBundleSelectionPayload(product) {
    const variant = this.getMealsVariant(product.variants);
    return {
      collectionId: this.getPrimararyCollection(product).id,
      externalProductId: product.id,
      externalVariantId: variant.id,
    };
  },

  async addDynamicBundleProps(lineItems) {
    const selections = lineItems.map(
      (item) => {
        const product = window.mosaic.products.find(
          (candidateProduct) => candidateProduct.variants.find(
            (variant) => (`gid://shopify/ProductVariant/${variant.id}` === item.merchandiseId),
          ),
        );
        const productPayload = this.getBundleSelectionPayload(product);
        productPayload.quantity = item.quantity;
        if ('sellingPlanId' in item) {
          productPayload.sellingPlanId = item.sellingPlanId.split('/').pop();
        }
        return productPayload;
      },
    );

    const wrappedPayload = {
      externalVariantId: window.themeConfiguration.bundleArchitecture.product.variantId,
      externalProductId: window.themeConfiguration.bundleArchitecture.product.id,
      selections,
    };

    const rechargeBundleLineItems = await window.recharge.bundle.getDynamicBundleItems(
      wrappedPayload,
      window.themeConfiguration.bundleArchitecture.product.handle,
    );

    for (let i = 0; i < rechargeBundleLineItems.length; i++) {
      const lineItemProperties = rechargeBundleLineItems[i].properties;
      lineItems[i].attributes = [];

      for (const [key, value] of Object.entries(lineItemProperties)) {
        if (value) {
          lineItems[i].attributes.push({
            key,
            value: String(value),
          });
        }
      }
    }
    return lineItems;
  },

  getShippingFrequency(basket, onetimeOrder) {
    if (onetimeOrder) {
      return null;
    }
    // eslint-disable-next-line camelcase
    let shippingFrequency = null;

    if (basket.items[0] && basket.items[0].properties && basket.items[0].properties.shipping_interval_frequency) {
      shippingFrequency = basket.items[0].properties.shipping_interval_frequency;
    }

    if (!shippingFrequency) {
      console.warn('Could not determine shipping frequency from basket items. Falling back to default shipping frequency.');
      return window.themeConfiguration.defaultShippingFrequency;
    }
    return shippingFrequency;
  },

  shouldCreateDynamicBundle(basket) {
    if (!window.themeConfiguration.bundleArchitecture.enabled) {
      return false;
    }

    return !basket.items.some((item) => {
      const product = this.cartItemToProduct(item);
      return product && product.type === 'Bundle';
    });
  },

  async createShopifyCart(basket, cartAttributes = {}, onetimeOrder = false) {
    const shippingFrequency = this.getShippingFrequency(basket, onetimeOrder);
    let lineItems = basket.items.map(
      (item) => this.getShopifyProductPayload(
        this.cartItemToProduct(item),
        item.quantity,
        shippingFrequency,
        onetimeOrder,
      ),
    );

    if (basket.getPackageProtection()) {
      const {packageProtection: {product: {handle}}} = window.themeConfiguration;
      const packageProtectionProduct = window.mosaic.products.find(
        (product) => product.handle === handle,
      );

      // Strangely, we need to add package protection to the begining of
      // the line items to have it show up last in Shopify checkout.
      lineItems.unshift(
        this.getShopifyProductPayload(
          packageProtectionProduct,
          1,
          shippingFrequency,
          onetimeOrder,
        ),
      );
    }

    lineItems = await Promise.all(lineItems);

    if (this.shouldCreateDynamicBundle(basket)) {
      // Add props to each line item to support dynamic bundle. 
      lineItems = await this.addDynamicBundleProps(lineItems);
    }

    try {
      return await this._sendShopifyCartRequest(
        cartAttributes,
        lineItems,
        window.urlParams.get('email'),
      );
    } catch (error) {
      if (error.message === 'ShopifyCartCreateEmailError') {
        // If the error is related to the customer's email, we can send them to
        // checkout without the email prefilled.
        console.warn("Could not create cart with customer's email. Trying again without it.");
        return this._sendShopifyCartRequest(
          cartAttributes,
          lineItems,
        );
      }
      throw error;
    }
  },

  updateItemProps({properties, index, item, defer = false}) {
    const product = window.mosaic.products.find((p) => p.id === Number(item.product_id));
    const variant = this.getMealsVariant(product.variants);
    window.basket.changeItemByLine({
      line: (index + 1),
      variantId: variant.id,
      quantity: item.quantity,
      properties,
      defer,
    });
  },

  savingAnimation(selector, messaging) {
    self.transitioning = true;
    const $btn = $(selector);
    $btn.css({
      'background-color': 'var(--celebration-color)',
      color: 'var(--primary-contrast-color)',
      border: 'none',
    });
    $btn.first().html(`${messaging} <i class="fas fa-sync-alt rotating"></i>`);
  },

  errorSaveAnimation(selector, message) {
    const $btn = $(selector);
    const $btnContent = $btn.first();
    $btn.css({
      'background-color': '#a84934',
      color: '#fff',
      border: 'none',
    });
    $btnContent.html(message);
  },

  finishSaveAnimation(selector, messaged, message) {
    const $btn = $(selector);
    const $btnContent = $btn.first();
    $btnContent.html(`${messaged} <i class="fas fa-check-circle"></i>`);
    setTimeout(() => {
      $btn.fadeOut('slow', () => {
        $btn.css({
          'background-color': '#01666a',
          color: '#fff',
          border: 'none',
        });
        $btnContent.html(message);
        $btn.fadeIn('slow', () => {
          self.transitioning = false;
          self.skipped = true;
        });
      });
    }, 1000);
  },


  buttonToProcessingState(button, message) {
    button.addClass('processing-state');
    button.html(`${message} <i class="fas fa-sync-alt"></i>`);
  },

  buttonToNormalState(button, message) {
    button.removeClass('processing-state');
    button.removeClass('completed-state');
    button.html(message);
  },

  buttonToCompletedState(button, message) {
    button.addClass('completed-state');
    button.html(`${message} <i class="fas fa-check-circle"></i>`);
  },

  updateFrequency(frequency) {
    if (!window.basket) {
      return;
    }

    const chargeDelay = frequency * 7;

    window.basket.items.forEach((item, index) => {
      const properties = {
        ...frequency == 0 ? {
          onetime: true,
        } : {
          subscription_id: item.subscription_product_id,
          shipping_interval_unit_type: 'weeks',
          shipping_interval_frequency: frequency,
        },
      };
      if (chargeDelay > 0) {
        properties.charge_delay = chargeDelay;
      }

      this.updateItemProps({properties, index, item, defer: true});
    });

    window.basket._update();
  },

  getSubscriptionFrequency(subs) {
    if (subs[0] === undefined) { return false; }
    // iterate subscription items' frequencies
    // if there are inconsistencies return false, otherwise return freq
    const freqKey = 'charge_interval_frequency';
    const freq = subs[0][freqKey];
    return subs.every((sub) => sub[freqKey] === freq) && freq;
  },

  // A/B test force optimize cadence
  isFrequency(cadence = 1) {
    const frequency = this.getUrlParam('frequency');
    return frequency === `${cadence}`;
  },

  detectOnetimeOrder() {
    // Check whether we are in the context of a one time or subscription
    // purchase flow. This is an extremely imperfect tool.

    // Check the URL for a param called frequency
    const frequencyParam = this.getUrlParam('frequency');
    if (frequencyParam) {
      return frequencyParam === '0';
    }

    // Check for any DOM element with a data attribute frequency
    const dataAttrFreq = document.querySelector('[data-frequency]');
    if (dataAttrFreq) {
      return dataAttrFreq.dataset.frequency === '0';
    }

    // Check for any form input with a name of frequency
    const frequencyInput = document.querySelector('input[name=frequency]');
    if (frequencyInput) {
      return frequencyInput.value === '0';
    }

    return null;
  },

  getErrorLogger() {
    return window.Rollbar || console;
  }


};
